import DocsAlert from '@/common/assets/icons/docsAlert.svg?react';
import LeftArrow from '@/common/assets/icons/leftArrow.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import useModal from '@/common/hooks/useModal';
import { reasonAlertType } from '@/modules/FileDetail/queries/alerts/alertsQuery.type';
import { Box } from 'styled-system/jsx';
import ReasonModal from '@/modules/FileDetail/components/renderAlert/alerts/modals/reasonModal/ReasonModal.tsx';
import { token } from 'styled-system/tokens';

const ReasonAlert = ({
  reasonAlertItem,
}: {
  reasonAlertItem: reasonAlertType;
}) => {
  const { open, closeModal, openModal } = useModal();

  return (
    <>
      <Box
        p="12px 16px"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        border="1px solid"
        borderColor="red-1"
        borderRadius="8px"
        shadow="cardShadow"
        onClick={openModal}
        cursor="pointer"
      >
        <Box display="flex" alignItems="center" gap="8px">
          <DocsAlert />
          <Typography textStyle="b2" color="black-1">
            {reasonAlertItem.fa_type}
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" gap="8px">
          <Typography textStyle="b4" color="red">
            مشاهده
          </Typography>
          <LeftArrow stroke={token('colors.red')} />
        </Box>
      </Box>
      <ReasonModal
        open={open}
        closeModal={closeModal}
        reasonAlertItem={reasonAlertItem}
      />
    </>
  );
};
export default ReasonAlert;
